module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-120x120-f4fcd9a40c208fd3c495ba5a6312620a.png";